import { render, staticRenderFns } from "./appDefaultLogo.vue?vue&type=template&id=6cbaff00"
import script from "./appDefaultLogo.vue?vue&type=script&lang=js"
export * from "./appDefaultLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports